/** @format */

import { LI } from "../../../AbstractElements";
export default function Syncing() {
  return (
    <LI className="cart-nav onhover-dropdown flex">
      <i className="fa fa-spin fa-refresh"></i>
    </LI>
  );
}
